<template>
  <div class="group-introduction">
    <van-nav-bar
      title="集团介绍"
      left-arrow
      fixed
      placeholder
      @click-left="$router.back()"
    />

    <div class="iframe-container">
      <iframe
        :src="externalUrl"
        frameborder="0"
        class="group-iframe"
        @load="iframeLoaded = true"
      />

      <!-- 加载状态 -->
      <div
        v-if="!iframeLoaded"
        class="loading-state"
      >
        <van-loading
          type="spinner"
          size="24px"
        >
          加载中...
        </van-loading>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'

export default {
  name: 'GroupIntroduction',
  setup () {
    const externalUrl = ref('http://www.geekfashiongroup.com')
    const iframeLoaded = ref(false)

    return {
      externalUrl,
      iframeLoaded
    }
  }
}
</script>

<style lang="scss" scoped>
.iframe-container {
  position: relative;
  width: 100%;
  height: calc(100vh - 46px);

  .group-iframe {
    width: 100%;
    height: 100%;
  }

  .loading-state {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;

    .van-loading {
      display: block;
      margin-bottom: 8px;
    }
  }
}
</style>
